import {
  MetricTrendCardData,
  PartnerDashboardData,
} from "../types";

/** Set to false once these dashboard blocks are wired to live APIs. */
export const STATIC_DASHBOARD_BLOCKS_DISABLED = true;

const STATIC_METRIC_CHARTS: Pick<
  MetricTrendCardData,
  "id" | "label" | "badgeVariant" | "chartColor" | "chartPoints"
>[] = [
  {
    id: "metric-users",
    label: "TOTAL USERS",
    badgeVariant: "green",
    chartColor: "#10B981",
    chartPoints: [
      { month: "Feb", value: 32 },
      { month: "Mar", value: 38 },
      { month: "Apr", value: 35 },
      { month: "May", value: 46 },
      { month: "Jun", value: 52 },
    ],
  },
  {
    id: "metric-licenses",
    label: "TOTAL LICENSE",
    badgeVariant: "blue",
    chartColor: "#0057B7",
    chartPoints: [
      { month: "Feb", value: 98 },
      { month: "Mar", value: 108 },
      { month: "Apr", value: 115 },
      { month: "May", value: 128 },
      { month: "Jun", value: 142 },
    ],
  },
  {
    id: "metric-growth",
    label: "TOTAL GROWTH",
    badgeVariant: "purple",
    chartColor: "#7C3AED",
    chartPoints: [
      { month: "Feb", value: 28 },
      { month: "Mar", value: 34 },
      { month: "Apr", value: 31 },
      { month: "May", value: 39 },
      { month: "Jun", value: 45 },
    ],
  },
];

const PLACEHOLDER_METRICS: MetricTrendCardData[] = STATIC_METRIC_CHARTS.map(
  (metric) => ({
    ...metric,
    value: "0",
    badge: "0",
  })
);

export const STATIC_PARTNER_DASHBOARD_DATA: Omit<
  PartnerDashboardData,
  | "kpiCards"
  | "contractStatus"
  | "orders"
  | "projects"
  | "projectFilters"
  | "partnerProgram"
> = {
  supportStatus: {
    canSupport: true,
    supportLevel: "Tier 2",
  },
  openActionsCount: 0,
  pendingActions: [],
  eventsWeek: {
    months: ["January", "February", "March"],
    activeMonthIndex: 0,
    weekDays: [
      { label: "Sun", date: 0 },
      { label: "Mon", date: 0 },
      { label: "Tue", date: 0 },
      { label: "Wed", date: 0 },
      { label: "Thu", date: 0 },
      { label: "Fri", date: 0 },
      { label: "Sat", date: 0 },
    ],
    events: [],
  },
  escalations: {
    openTicketsLink: "0 Open Tickets",
    footerLinkLabel: "View Full Issue Tracker",
    summary: [
      { label: "Total", value: 0 },
      { label: "Open", value: 0 },
      { label: "Resolved", value: 0 },
    ],
    tickets: [],
  },
  endCustomerEcosystem: {
    subtitle: "Detailed performance by wallet technology and organization.",
    technologyTabs: ["Apple Wallet", "Google Wallet", "App Based", "IDP"],
    totalEndCustomers: 0,
    activeRegions: [],
    customers: [
      {
        id: "placeholder-customer",
        name: "—",
        customerId: "—",
        region: "—",
        licenses: 0,
        users: 0,
      },
    ],
    metrics: PLACEHOLDER_METRICS,
  },
};
